import { render } from "./hoverEffect8.vue?vue&type=template&id=c65a0d18"
import script from "./hoverEffect8.vue?vue&type=script&lang=js"
export * from "./hoverEffect8.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__